import { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
	{
		component: () => import('src/pages/oauth/OAuthAuthorizePage.vue'),
		meta: {
			bottomMenuFavoritesShouldBeVisible: false,
			bottomMenuFilterShouldBeVisible: false,
			bottomMenuShouldBeVisible: false,
			bottomMenuTabsShouldBeVisible: false,
			keepAlive: false,
			mainMenuItemName: 'settings',
			type: 'activityDetails',
		},
		name: 'OAuthAuthorizePage',
		path: '/oauth/authorize/:instance',
	},
	{
		component: () => import('src/pages/oauth/OAuthConsentPage.vue'),
		meta: {
			bottomMenuFavoritesShouldBeVisible: false,
			bottomMenuFilterShouldBeVisible: false,
			bottomMenuShouldBeVisible: false,
			bottomMenuTabsShouldBeVisible: false,
			keepAlive: false,
			mainMenuItemName: 'settings',
			type: 'activityDetails',
		},
		name: 'OAuthConsentPage',
		path: '/oauth/consent/:handle',
	},
	{
		children: [
			{
				component: () => import('src/components/inbox/InboxList.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: true,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: true,
					keepAlive: true,
					mainMenuItemName: 'inbox',
					scrollPos: {
						left: 0,
						top: 0,
					},
					scrollPosElement: 'moduleActivityListScrollerInbox',
					type: 'activityList',
				},
				name: 'inbox',
				path: '',
			},
			{
				component: () => import('src/components/appointment/Agenda.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: true,
					bottomMenuShouldBeVisible: true,
					// The calendar has year/month/week/day views, not open/mine/all.
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: true,
					mainMenuItemName: 'agendaList',
					scrollPos: {
						left: 0,
						top: 0,
					},
					scrollPosElement: '',
					type: 'activityList',
				},
				name: 'agendaList',
				path: '/agenda/:view?/:date?/:source?',
			},
			{
				component: () => import('src/components/workspace/AddonSurface.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: false,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: false,
					mainMenuItemName: 'addOns',
				},
				name: 'addon',
				path: '/addon/:id',
			},
			{
				component: () => import('src/components/appointment/AppointmentDetail.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: false,
					mainMenuItemName: 'agendaList',
					scrollPos: {
						left: 0,
						top: 0,
					},
					scrollPosElement: 'historyActivityListScroller',
					type: 'activityDetails',
				},
				name: 'appointment',
				path: '/appointment/:id/:activityListLocation/:editOrView',
			},
			{
				component: () => import('src/components/ido/idoList/index.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: true,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: true,
					mainMenuItemName: 'records',
					scrollPos: {
						left: 0,
						top: 0,
					},
					scrollPosElement: 'moduleActivityListScrollerIdos',
					type: 'activityList',
				},
				name: 'records',
				path: '/records/:instanceId?/:sharedQueryId?',
			},
			{
				component: () => import('src/components/notebook/NotebookList.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: true,
					mainMenuItemName: 'folderExplorer',
					scrollPos: {
						left: 0,
						top: 0,
					},
					scrollPosElement: 'moduleActivityListScrollerNotebookList',
					type: 'activityList',
				},
				name: 'notebookList',
				path: '/notebooks/:notebookId',
			},
			{
				component: () => import('src/pages/OrganizationPage.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					mainMenuItemName: 'folderExplorer',
				},
				name: 'organization',
				path: '/organization',
			},
			{
				component: () => import('src/components/mail/MailList.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: true,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: true,
					keepAlive: true,
					mainMenuItemName: 'mailList',
					scrollPos: {
						left: 0,
						top: 0,
					},
					scrollPosElement: 'moduleActivityListScrollerMails',
					type: 'activityList',
				},
				name: 'mailList',
				path: '/mails/:view/:date/:source',
			},
			{
				component: () => import('src/components/mail/MailDetail.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: false,
					mainMenuItemName: 'mailList',
					type: 'activityDetails',
				},
				name: 'mail',
				path: '/mail/:id/:activityListLocation/:editOrView/:tab?',
			},
			{
				component: () => import('src/components/mail/MailCreate.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: false,
					mainMenuItemName: 'mailList',
					type: 'activityDetails',
				},
				name: 'mailSendWithReceiver',
				path: '/mailSend/:receiverAddressTo?',
			},
			{
				component: () => import('src/components/mail/MailCreate.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: false,
					mainMenuItemName: 'mailList',
					type: 'activityDetails',
				},
				name: 'mailSend',
				path: '/mailSend/:replyOrForwardType?/:replyOrForwardId?/:draftIdToLoad?',
			},
			{
				component: () => import('src/components/phoneCall/PhoneCallList.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: true,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: true,
					keepAlive: true,
					mainMenuItemName: 'phoneCallList',
					scrollPos: {
						left: 0,
						top: 0,
					},
					scrollPosElement: 'moduleActivityListScrollerPhoneCalls',
					type: 'activityList',
				},
				name: 'phoneCallList',
				path: '/phoneCalls/:view/:date/:source',
			},
			{
				component: () => import('src/components/phoneCall/PhoneCallDetail.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: false,
					mainMenuItemName: 'phoneCallList',
					scrollPos: {
						left: 0,
						top: 0,
					},
					scrollPosElement: 'historyActivityListScroller',
					type: 'activityDetails',
				},
				name: 'phoneCall',
				path: '/phoneCall/:id/:activityListLocation/:editOrView/:isAManuallyCreation?',
			},
			{
				component: () => import('src/components/phoneCall/PhoneBook.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: false,
					mainMenuItemName: 'phoneCallList',
					scrollPos: {
						left: 0,
						top: 0,
					},
					scrollPosElement: 'historyActivityListScroller',
					type: 'activityDetails',
				},
				name: 'PhoneBook',
				path: '/PhoneBook',
			},
			{
				component: () => import('src/components/phoneCall/PhoneCallCreate.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: false,
					mainMenuItemName: 'phoneCallList',
					type: 'activityDetails',
				},
				name: 'phoneCallCreate',
				path: '/phoneCallCreate/:id/:desiredPhoneNumberToContact',
			},
			{
				component: () => import('src/components/message/MessageList.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: true,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: true,
					keepAlive: true,
					mainMenuItemName: 'messageList',
					scrollPos: {
						left: 0,
						top: 0,
					},
					scrollPosElement: 'moduleActivityListScrollerMessages',
					type: 'activityList',
				},
				name: 'messageList',
				path: '/messages/:view/:date/:source',
			},
			{
				component: () => import('src/components/message/MessageDetail.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: false,
					mainMenuItemName: 'messageList',
					scrollPosElement: 'historyActivityListScroller',
					type: 'activityDetails',
				},
				name: 'message',
				path: '/message/:id/:activityListLocation/:editOrView/:communicationPartnerUserId?',
			},
			{
				component: () => import('src/components/task/TaskList.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: true,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: true,
					keepAlive: true,
					mainMenuItemName: 'taskList',
					scrollPos: {
						left: 0,
						top: 0,
					},
					scrollPosElement: 'moduleActivityListScrollerTasks',
					type: 'activityList',
				},
				name: 'taskList',
				path: '/tasks/:view/:date/:source',
			},
			{
				component: () => import('src/components/task/TaskDetail.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: false,
					mainMenuItemName: 'taskList',
					scrollPos: {
						left: 0,
						top: 0,
					},
					scrollPosElement: 'historyActivityListScroller',
					type: 'activityDetails',
				},
				name: 'task',
				path: '/task/:id/:activityListLocation/:editOrView/:tab?',
			},
			{
				component: () => import('src/components/note/NoteList.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: true,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: true,
					keepAlive: true,
					mainMenuItemName: 'noteList',
					scrollPos: {
						left: 0,
						top: 0,
					},
					scrollPosElement: 'moduleActivityListScrollerNotes',
					type: 'activityList',
				},
				name: 'noteList',
				path: '/notes/:view/:date/:source',
			},
			{
				component: () => import('src/components/note/NoteDetail.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: false,
					mainMenuItemName: 'noteList',
					scrollPos: {
						left: 0,
						top: 0,
					},
					scrollPosElement: 'historyActivityListScroller',
					type: 'activityDetails',
				},
				name: 'note',
				path: '/note/:id/:activityListLocation/:editOrView',
			},
			{
				component: () => import('src/components/document/DocumentList.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: true,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: true,
					keepAlive: true,
					mainMenuItemName: 'documentList',
					scrollPos: {
						left: 0,
						top: 0,
					},
					scrollPosElement: 'moduleActivityListScrollerDocuments',
					type: 'activityList',
				},
				name: 'documentList',
				path: '/documents/:view/:date/:source',
			},
			{
				component: () => import('src/components/document/DocumentDetail.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: false,
					mainMenuItemName: 'documentList',
					type: 'activityDetails',
				},
				name: 'document',
				path: '/document/:id/:activityListLocation/:editOrView',
			},
			{
				component: () => import('src/components/ido/idoDetail/IdoDetail.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: true,
					mainMenuItemName: 'records',
					type: 'activityDetails',
				},
				name: 'record',
				path: '/record/:id/:activityListLocation/:editOrView/:tab?',
			},
			{
				component: () => import('src/components/ido/idoRelationsHistory/IdoRelationsHistory.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: false,
					mainMenuItemName: 'records',
					type: 'activityDetails',
				},
				name: 'relationsHistory',
				path: '/relations-history/:id',
			},
			{
				component: () => import('src/components/memo/MemoDetail.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: true,
					mainMenuItemName: 'records',
					type: 'activityDetails',
				},
				name: 'memo',
				path: '/memo/:id/:activityListLocation/:editOrView/:tab?',
			},
			{
				component: () => import('src/components/trash/TrashList.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: true,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: true,
					keepAlive: true,
					mainMenuItemName: 'trashList',
					scrollPos: {
						left: 0,
						top: 0,
					},
					scrollPosElement: 'moduleActivityListScrollerTrashes',
					type: 'activityList',
				},
				name: 'trashList',
				path: '/trashed/:view/:date/:source',
			},
			{
				component: () => import('src/components/filter/FilterList.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: true,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: true,
					keepAlive: true,
					mainMenuItemName: 'filterList',
					scrollPos: {
						left: 0,
						top: 0,
					},
					scrollPosElement: 'moduleActivityListScrollerFilters',
					type: 'activityList',
				},
				name: 'filterList',
				path: '/filter/:view/:date/:source',
			},
			{
				component: () => import('src/components/userOnline/UserOnline.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: true,
					mainMenuItemName: 'userOnline',
					scrollPos: {
						left: 0,
						top: 0,
					},
					scrollPosElement: 'moduleActivityListScrollerFilters',
					type: 'activityList',
				},
				name: 'userOnline',
				path: '/userOnline',
			},
			{
				component: () => import('src/components/settings/SettingsPage.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: true,
					mainMenuItemName: 'settings',
					scrollPos: {
						left: 0,
						top: 0,
					},
					scrollPosElement: 'moduleActivityListScrollerFilters',
					type: 'activityList',
				},
				name: 'settings',
				path: '/settings/:selectedSettingsTab',
			},
			{
				component: () => import('src/components/timer/TimerMobilePage.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: true,
					mainMenuItemName: 'timer',
					type: 'activityList',
				},
				name: 'timer',
				path: '/timer',
			},
			{
				component: () => import('src/components/kanban/KanbanPage.vue'),
				meta: {
					bottomMenuFavoritesShouldBeVisible: false,
					bottomMenuFilterShouldBeVisible: false,
					bottomMenuShouldBeVisible: true,
					bottomMenuTabsShouldBeVisible: false,
					keepAlive: true,
					mainMenuItemName: 'kanbanBoard',
					type: 'kanban',
				},
				name: 'kanbanBoard',
				path: '/kanban',
			},
		],
		component: () => import('layouts/MainLayout.vue'),
		name: 'main',
		path: '/',
	},
	{
		children: [
			{
				component: () => import('pages/LoginPage.vue'),
				name: 'login',
				path: '',
			},
		],
		component: () => import('layouts/LoginLayout.vue'),
		name: 'Login',
		path: '/login',
	},
	{
		children: [
			{
				component: () => import('pages/VersionMismatchPage.vue'),
				name: 'versionMismatch',
				path: '',
			},
		],
		component: () => import('layouts/VersionMismatchLayout.vue'),
		name: 'VersionMismatch',
		path: '/versionMismatch',
	},
	{
		component: () => import('pages/ErrorPageNotFound.vue'),
		path: '/:catchAll(.*)*',
	},
];

export default routes;
